<template>
    <div class="card-invoice">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'card-invoice'
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>